module.exports = __webpack_public_path__ + "assets/benefits-signup-1bbd32.svg";